import { Base } from './base.js'

const RequiredKeys = Object.freeze(['name', 'videoURL'])

class VideoSelector extends Base {
  constructor ({ name, status = 'paused', videoURL, videoData = {}, embedSource = undefined, referer = undefined, position = 0.0, lastPlayTimestampMS = -1 }) {
    super()
    Object.assign(this, {
      name,
      status,
      videoURL,
      videoData,
      embedSource,
      referer,
      position,
      lastPlayTimestampMS
    })

    const missingKeys = RequiredKeys.map(key => this[key] ? undefined : key).filter(e => e !== undefined)
    if (missingKeys.length > 0) {
      throw new Error(`Missing keys while creating VideoSelector (${JSON.stringify(missingKeys)}) data=${JSON.stringify(this)}`)
    }
  }
}

export {
  VideoSelector,
  RequiredKeys
}
